import { MdKeyboardArrowDown } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const NavSubLink = ({ label, href, sublinks, clickFn }) => {
  const navigate = useNavigate();
  return (
    <li
      className="flex group items-center cursor-pointer relative group "
      onClick={clickFn}
    >
      <a href={href} className="md:hover:text-[#e60000] text-2xl md:text-xl">
        {label}
      </a>
      <MdKeyboardArrowDown className="group-hover:-rotate-180 transition-all" />
      <ul className="absolute w-auto bg-white py-5 text-black z-30 rounded-lg right-0 top-full space-y-3 text-base group-hover:block hidden">
        {sublinks.map((sublink) => {
          return (
            <li key={sublink.label} className="hover:bg-[#d9d9d9] px-10 py-2">
              <p
                className="block w-max"
                // href={sublink.href}
                onClick={() => navigate(`${sublink.href}`)}
              >
                {sublink.label}
              </p>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default NavSubLink;
